(function () {
  angular.module('lif.controllers').controller('fileBlockController', fileBlockController);
  fileBlockController.$inject = ['$scope', '$rootScope', '$timeout', 'formService', 'uploadValues', 'userService', 'constants'];

  function fileBlockController($scope, $rootScope, $timeout, formService, uploadValues, userService, constants) {
    var vm = this;
    vm.showAddFileInformation = false;
    vm.showUploadSuccessMessage = false;
    vm.isBusy = false;
    vm.deletingFile = false;
    vm.fileToRemove = {};
    vm.maximumAmountOfFilesToShow = 100;
    vm.isEditable = uploadValues.isEditable == 'True';
    vm.files = [];

    var getRemoveFileModalName = function getRemoveFileModalName() {
      return "#removeFileItemModal-" + vm.blockSpecificUploadFolder;
    };

    vm.getFileTypeIcon = function (fileName) {
      return fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase() + '.png';
    };

    vm.addFile = function () {
      vm.showAddFileInformation = !vm.showAddFileInformation;
      $timeout(function () {
        window.resizeLeftNavbar();
      }, 400);
    };

    vm.showRemoveFileModal = function (file) {
      vm.fileToRemove = file;
      $(getRemoveFileModalName()).modal("show");
    };

    vm.removeFile = function () {
      vm.deletingFile = true;
      formService.deleteFile(uploadValues.deleteUrl, vm.fileToRemove.ContentId).then(function (result) {
        var counter = 0;
        var keepGoing = true;
        vm.files.forEach(function (f) {
          if (keepGoing) {
            if (f.Title === vm.fileToRemove.Title && f.Date === vm.fileToRemove.Date) {
              vm.files.splice(counter, 1);
              keepGoing = false;
              var event = {
                Date: new Date().toJSON().slice(0, 10),
                Message: "Tog bort " + vm.fileToRemove.Title + " från " + uploadValues.title,
                User: userService.getLoggedInUser().name,
                GroupEventType: constants.GroupEventType.File,
                Action: constants.Action.Delete,
                Id: undefined
              };
              $rootScope.$broadcast('groupEvent', event);
            } else {
              counter++;
            }
          }
        });
        $(getRemoveFileModalName()).modal("hide");
        vm.deletingFile = false;
      }, function () {
        //error
        $(getRemoveFileModalName()).modal("hide");
        vm.deletingFile = false;
      });
    };

    var startingFoldersAmount = undefined;

    vm.showMoreFiles = function () {
      if (startingFoldersAmount === undefined) {
        startingFoldersAmount = vm.numberOfFilesToShow;
      }

      if (vm.numberOfFilesToShow == startingFoldersAmount) {
        vm.numberOfFilesToShow = vm.maximumAmountOfFilesToShow;
      } else {
        vm.numberOfFilesToShow = startingFoldersAmount;
      }
    };

    $scope.$watch('filesToUpload', function () {
      if ($scope.filesToUpload !== undefined && $scope.filesToUpload != null && $scope.filesToUpload.length > 0 && uploadValues !== undefined && vm.blockSpecificUploadFolder !== undefined) {
        vm.isBusy = true;
        formService.uploadFiles($scope.filesToUpload, uploadValues.url, parseInt(vm.blockSpecificUploadFolder)).then(function (results) {
          vm.isBusy = false;
          results.forEach(function (r) {
            vm.files.unshift({
              Title: r.FileName,
              ImageName: r.ImageName,
              Date: r.Date,
              ContentId: r.ContentId,
              Url: r.Url
            });
            var event = {
              Date: new Date().toJSON().slice(0, 10),
              Message: "Lade till " + r.FileName + " i " + uploadValues.blockTitle,
              User: userService.getLoggedInUser().name,
              Id: undefined,
              GroupEventType: constants.GroupEventType.File,
              Action: constants.Action.Add
            };
            $rootScope.$broadcast('groupEvent', event);
          });
          vm.showAddFileInformation = false;
        }, function () {
          vm.isBusy = false; //error
        });
      }
    });
  }
})();